import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Flex,
  FormField,
  Label,
  Select,
  Input
} from 'pcln-design-system'
import { Calendar, Clock, Cruises, Pin, Search, User } from 'pcln-icons'
import styled from 'styled-components'
import _ from 'lodash'
import moment from 'moment/moment'
import { FindYourDealButton } from '../../shared'
import { CRUISE_PRODUCT_TYPE } from '../../constants/Constants'

// TODO: hack; needs fixed in design system
const Root = styled(Flex)`
  & ${Flex} {
    width: 100%;
  }
`

const StyledInput = styled(Input)`
  background-color: white;
`

const StyledSelect = styled(Select)`
  background-color: white;
  cursor: pointer;
`

const createOption = ({ label, value, disabled }, i) => ({
  label,
  value,
  disabled,
  key: value + i
})

const locationOptions = [
  { value: '', label: 'Where are you going?', disabled: true },
  { value: 'C', label: 'Caribbean' },
  { value: 'M', label: 'Mexico' },
  { value: 'BH', label: 'Bahamas' },
  { value: 'A', label: 'Alaska' },
  { value: 'E', label: 'Europe - All' },
  { value: 'H', label: 'Hawaii' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'NN', label: 'Canada/New England/NY' },
  { value: '_', disabled: true, label: '-------------' },
  { value: 'ALL', label: 'All Destinations' },
  { value: 'A', label: 'Alaska - All' },
  { value: 'AG', label: 'Alaska - Gulf of Alaska' },
  { value: 'AR', label: 'Alaska - Inside Passage' },
  { value: 'AB', label: 'Antarctica' },
  { value: 'UN', label: 'Australia/New Zealand' },
  { value: 'BH', label: 'Bahamas' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'NN', label: 'Canada/New England/NY' },
  { value: 'C', label: 'Caribbean - All' },
  { value: 'CE', label: 'Caribbean - Eastern' },
  { value: 'CS', label: 'Caribbean - Southern' },
  { value: 'CW', label: 'Caribbean - Western' },
  { value: 'CN', label: 'Cruise to Nowhere' },
  { value: 'E', label: 'Europe - All' },
  { value: 'EE', label: 'Europe - E. Mediterranean' },
  { value: 'R', label: 'Europe - Mediterranean - All' },
  { value: 'N', label: 'Europe - Northern' },
  { value: 'EW', label: 'Europe - W. Mediterranean' },
  { value: 'W', label: 'Europe - Western' },
  { value: 'O', label: 'Exotic - Asia/Africa/Other' },
  { value: 'H', label: 'Hawaii' },
  { value: 'M', label: 'Mexico' },
  { value: 'T', label: 'Panama Canal/C. America' },
  { value: 'S', label: 'South America' },
  { value: 'I', label: 'South Pacific - All' },
  { value: 'TH', label: 'South Pacific - Tahiti' },
  { value: 'ET', label: 'Transatlantic' },
  { value: 'NA', label: 'U.S. - All' },
  { value: 'RV', label: 'U.S. - American Rivers' },
  { value: 'PC', label: 'U.S. - Pacific/Northwest' },
  { value: 'NC', label: 'U.S. - Southeast' },
  { value: 'WW', label: 'World Cruise' }
].map(createOption)

const cruiseLineOptions = [
  { value: '', label: 'Which cruise line?', disabled: true },
  { value: 'ALL', label: 'All Cruise Lines' },
  { value: '92', label: 'AmaWaterways' },
  { value: '329', label: 'Avalon Waterways' },
  { value: '325', label: 'Azamara Cruises' },
  { value: '1', label: 'Carnival Cruise Lines' },
  { value: '11', label: 'Celebrity Cruises' },
  { value: '14', label: 'Costa Cruises' },
  { value: '17', label: 'Crystal Cruises' },
  { value: '18', label: 'Cunard' },
  { value: '20', label: 'Disney Cruise Line' },
  { value: '24', label: 'Holland America Line' },
  { value: '338', label: 'Hurtigruten Cruises' },
  { value: '71', label: 'MSC Cruises' },
  { value: '34', label: 'Norwegian Cruise Line' },
  { value: '67', label: 'Oceania Cruises' },
  { value: '344', label: 'Ponant' },
  { value: '40', label: 'Princess Cruises' },
  { value: '41', label: 'Regent Seven Seas Cruises' },
  { value: '44', label: 'Royal Caribbean' },
  { value: '50', label: 'Silversea Cruises' },
  { value: '48', label: 'The Yachts of Seabourn' },
  { value: '66', label: 'Uniworld River Cruises' },
  { value: '78', label: 'Viking River Cruises' },
  { value: '364', label: 'Virgin Voyages' },
  { value: '64', label: 'Windstar Cruises' }
].map(createOption)

const createDateOptions = date => {
  const now = moment(date)
  const options = []
  const parseOptions = i => {
    const newMonth = now.clone().add(i, 'month')
    const monthDate = newMonth.format('MM/1/YYYY')
    options.push({
      value: monthDate,
      label: newMonth.format('MMMM YYYY'),
      key: monthDate
    })
  }

  _.times(24, parseOptions)
  return options
}

const durationOptions = [
  { value: '', label: 'Cruise length', disabled: true },
  { value: 'ALL', label: 'All' },
  { value: '1', label: '1-2 Nights' },
  { value: '2', label: '3-5 Nights' },
  { value: '3', label: '6-8 Nights' },
  { value: '4', label: '9-11 Nights' },
  { value: '5', label: '12+ Nights' }
].map(createOption)

const UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL = 'Under 55'
const UNDER_FIFTY_FIVE_SELECT_NO_LABEL = 'No'
const UNDER_FIFTY_FIVE_SELECT_YES_LABEL = 'YES'

const CruisesSearchForm = ({
  now,
  values: { location, cruiseLine, zip, startDate, duration, underFiftyFive },
  handleChange,
  handleBlur,
  handleSubmit,
  handleSelectOnFocus,
  handleInputOnFocus,
  role,
  id,
  ariaLabelledby
}) => {
  return (
    <form onSubmit={handleSubmit} aria-labelledby={ariaLabelledby} role={role} id={id}>
      <Root flexWrap='wrap' mx={-2} mb={-3}>
        <Box width={[1, 1 / 2, null, null, 2 / 5]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlFor='location'>
              Where are you going?
            </Label>
            <Search color='primary' />
            <StyledSelect
              id='location'
              name='location'
              value={location}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleSelectOnFocus('location select')}
            >
              {locationOptions.map(option => (
                <option {...option}>{option.label}</option>
              ))}
            </StyledSelect>
          </FormField>
        </Box>
        <Box width={[1, 1 / 2, null, null, 2 / 5]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlFor='cruiseLine'>
              Which cruise line?
            </Label>
            <Cruises color='primary' />
            <StyledSelect
              id='cruiseLine'
              name='cruiseLine'
              value={cruiseLine}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleSelectOnFocus('cruiseline select')}
            >
              {cruiseLineOptions.map(option => (
                <option {...option}>{option.label}</option>
              ))}
            </StyledSelect>
          </FormField>
        </Box>
        <Box width={[1, 1 / 2, null, null, 1 / 5]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlForm='zip'>
              ZIP code
            </Label>
            <Pin color='primary' />
            <StyledInput
              id='zip'
              name='zip'
              placeholder='ZIP code'
              minLength='5'
              maxLength='5'
              value={zip}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleInputOnFocus('zip input')}
            />
          </FormField>
        </Box>
        <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlFor='startDate'>
              Departing
            </Label>
            <Calendar color='primary' />
            <StyledSelect
              id='startDate'
              name='startDate'
              value={startDate}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleSelectOnFocus('startDate select')}
            >
              {createDateOptions(now).map(option => (
                <option {...option}>{option.label}</option>
              ))}
            </StyledSelect>
          </FormField>
        </Box>
        <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlFor='duration'>
              Cruise length
            </Label>
            <Clock color='primary' />
            <StyledSelect
              id='duration'
              name='duration'
              value={duration}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleSelectOnFocus('duration select')}
            >
              {durationOptions.map(option => (
                <option {...option}>{option.label}</option>
              ))}
            </StyledSelect>
          </FormField>
        </Box>
        <Box width={[1, 1 / 2, null, null, 1 / 4]} px={2} mb={3}>
          <FormField>
            <Label autoHide htmlFor='underFiftyFive'>
              Under 55
            </Label>
            <User color='primary' />
            <StyledSelect
              id='underFiftyFive'
              name='underFiftyFive'
              value={underFiftyFive}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={() => handleSelectOnFocus('underFiftyFive select')}
            >
              <option disabled value='' label='Under 55'>
                {UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL}
              </option>
              <option value={false} label='No'>
                {UNDER_FIFTY_FIVE_SELECT_NO_LABEL}
              </option>
              <option value label='Yes'>
                {UNDER_FIFTY_FIVE_SELECT_YES_LABEL}
              </option>
            </StyledSelect>
          </FormField>
        </Box>
        <Box width={[1, null, null, null, 1 / 4]} px={2} mb={3} ml='auto'>
          <FindYourDealButton currentProduct={CRUISE_PRODUCT_TYPE}>Find your deal</FindYourDealButton>
        </Box>
      </Root>
    </form>
  )
}

CruisesSearchForm.propTypes = {
  values: PropTypes.shape({
    location: PropTypes.string.isRequired,
    cruiseLine: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    duration: PropTypes.string.isRequired,
    underFiftyFive: PropTypes.bool.isRequired
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  now: PropTypes.object,
  handleSelectOnFocus: PropTypes.func,
  handleInputOnFocus: PropTypes.func,
  role: PropTypes.string,
  id: PropTypes.string,
  ariaLabelledby: PropTypes.string
}

CruisesSearchForm.defaultProps = {
  now: new Date(),
  values: {
    location: '',
    cruiseLine: '',
    zip: '',
    startDate: '',
    duration: '',
    underFiftyFive: ''
  }
}

export default CruisesSearchForm
